"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduceOption = exports.matcherMethodIgnoreCase = exports.isSame = exports.getAriaLabelledBy = void 0;
var _isFunction = require("../utils/isFunction");
var matcherMethodIgnoreCase = exports.matcherMethodIgnoreCase = function matcherMethodIgnoreCase(haystack, needle) {
  var matcherMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'startsWith';
  return typeof haystack === 'string' && typeof needle === 'string' && (haystack === null || haystack === void 0 ? void 0 : haystack.toLowerCase()[matcherMethod](needle === null || needle === void 0 ? void 0 : needle.toLowerCase()));
};
var reduceOption = exports.reduceOption = function reduceOption(option, fnOrKey) {
  var result;
  if ((0, _isFunction.isFunction)(fnOrKey)) {
    result = fnOrKey(option);
  } else {
    result = option && option[fnOrKey];
  }
  return result || '';
};
var isSame = exports.isSame = function isSame(option1, option2, itemKey) {
  return reduceOption(option1, itemKey) === reduceOption(option2, itemKey);
};
var getAriaLabelledBy = exports.getAriaLabelledBy = function getAriaLabelledBy(_ref) {
  var ariaLabelledby = _ref.ariaLabelledby,
    label = _ref.label,
    labelId = _ref.labelId;
  var labelledBy = [];
  if (ariaLabelledby) {
    labelledBy.push(ariaLabelledby);
  }
  if (label) {
    labelledBy.push(labelId);
  }
  return labelledBy.length > 0 ? labelledBy.join(' ') : undefined;
};